import { User as FirebaseUser } from '@angular/fire/auth';

import { baseUrl as baseUrlAdmin } from '../../admin/routes/routes';
import { baseUrl as baseUrlBrand } from '../../brand/routes/routes';
import { baseUrl as baseUrlCreator } from '../../creator/routes/routes';
import { baseUrl as baseUrlEditor } from '../../editor/routes/routes';
import { Language } from '../i18n/i18n';
import { routes } from '../routes/routes';
import { UserDto } from './dto/user.dto';
import { UserRole } from './user-role.enum';

interface UserBase {
  readonly authenticated: string;
  readonly email: string;
  readonly name: string;
  readonly redirectUrlAfterLogin: string;
}

export interface FullyAuthenticatedUser extends UserBase {
  readonly authenticated: 'fully';
  readonly canChangeEmail: boolean;
  readonly firstname: string;
  readonly lastname: string;
  readonly name: string;
  readonly role: UserRole;
  readonly language: Language;
}

export interface FirebaseOnlyAuthenticatedUser extends UserBase {
  readonly authenticated: 'firebase-only';
}

export type User = FullyAuthenticatedUser | FirebaseOnlyAuthenticatedUser;

export function createUser(firebaseUser: FirebaseUser, userDto: UserDto | null): User {
  if (userDto === null) {
    return {
      authenticated: 'firebase-only',
      email: firebaseUser.email ?? '',
      name: firebaseUser.displayName ?? '',
      redirectUrlAfterLogin: routes.onboarding.index.url(),
    };
  }

  return {
    authenticated: 'fully',
    email: firebaseUser.email ?? '',
    redirectUrlAfterLogin: redirectUrlAfterLogin(userDto),
    firstname: userDto.firstname,
    lastname: userDto.lastname,
    name: userDto.name,
    role: userDto.role,
    language: userDto.language,
    canChangeEmail: canChangeEmail(),
  };

  function canChangeEmail() {
    return firebaseUser.providerData.some(provider => provider.providerId === 'password');
  }

  function redirectUrlAfterLogin(dto: UserDto): string {
    if (dto.role === UserRole.Admin) return baseUrlAdmin;
    if (dto.role === UserRole.Creator) return baseUrlCreator;
    if (dto.role === UserRole.Brand || dto.role === UserRole.BrandAdmin) return baseUrlBrand;
    if (dto.role === UserRole.Editor) return baseUrlEditor;

    return '/';
  }
}
